const f = () => {
        const e = navigator.userAgent.toLowerCase();
        return ["mobile", "android", "silk/", "kindle", "blackberry", "opera mini", "opera mobi"].some(s => e.includes(s))
    },
    d = f(),
    m = !d,
    p = d ? "m" : "d";
window.D = {
    device: p,
    isSafari: navigator.userAgent.indexOf("Safari") > -1,
    isM: d,
    isD: m
};
window.M = {};
M.Is = {
    def: e => e !== void 0,
    und: e => e === void 0,
    str: e => typeof e == "string",
    obj: e => e === Object(e),
    arr: e => e?.constructor === Array,
    func: e => typeof e == "function",
    null: e => e === null,
    currentTg: e => e.target === e.currentTarget
};
M.XY = {
    offsetTop: (e, t = 0) => (e = M.Select(e), e.offsetParent ? M.XY.offsetTop(e.offsetParent, t + e.offsetTop) : e.offsetTop + t),
    offsetBottom: e => (e = M.Select(e), M.XY.offsetTop(e) + e.offsetHeight),
    offsetLeft: (e, t = 0) => (e = M.Select(e), e.offsetParent ? M.XY.offsetLeft(e.offsetParent, t + e.offsetLeft) : e.offsetLeft + t),
    Cx: e => (e = M.Select(e), M.XY.offsetLeft(e) + e.offsetWidth / 2),
    Cy: e => (e = M.Select(e), M.XY.offsetTop(e) + e.offsetHeight / 2),
    Current: e => {
        e = M.Select(e);
        const t = getComputedStyle(e),
            s = new WebKitCSSMatrix(t.transform);
        return {
            x: s.m41,
            y: s.m42
        }
    },
    overflowRight: e => {
        e = M.Select(e);
        const t = e.offsetWidth - (innerWidth - M.XY.offsetLeft(e));
        return M.Clamp(t, 0, t)
    }
};
M.G = {
    root: e => M.Is.def(e) ? e : document,
    s: (e, t, s) => {
        const i = M.G.root(e)["getElement" + t](s);
        return t === "ById" ? i : Array.from(i)
    },
    id: (e, t) => M.G.s(t, "ById", e),
    class: (e, t) => M.G.s(t, "sByClassName", e),
    tag: (e, t) => M.G.s(t, "sByTagName", e),
    attr: e => Array.from(document.querySelectorAll(e))
};
M.Pe = {
    fn: (e, t) => {
        M.Select(e).style.pointerEvents = t
    },
    all: e => {
        M.Pe.fn(e, "all")
    },
    none: e => {
        M.Pe.fn(e, "none")
    },
    auto: e => {
        M.Pe.fn(e, "auto")
    }
};
M.Index = (e, t) => {
    const s = M.L(t);
    for (let i = 0; i < s; i++)
        if (e === t[i]) return i;
    return -1
};
M.Clamp = (e, t, s) => Math.max(t, Math.min(s, e));
M.Lerp = (e, t, s) => e * (1 - s) + s * t;
M.Has = (e, t) => e ? e.hasOwnProperty(t) : !1;
M.Rand = (e, t) => Math.random() * (t - e) + e;
M.PD = e => {
    e.cancelable && e.preventDefault()
};
M.Bind = (e, t) => {
    t.forEach(s => {
        e[s] = e[s].bind(e)
    })
};
M.Select = e => M.Is.str(e) ? document.querySelector(e) : e;
M.SelectAll = e => M.Is.str(e) ? Array.from(document.querySelectorAll(e)) : M.Is.arr(e) ? e : !M.Is.und(e) && !M.Is.null(e) ? [e] : [];
M.Closest = (e, t) => (e = M.Select(e), e.closest(t));
M.Ga = (e, t) => e.getAttribute(t);
M.T = (e, t, s, i) => {
    if (e = M.Select(e), M.Is.null(e)) return;
    i = M.Is.und(i) ? "%" : i;
    const r = "translate3d(" + t + i + "," + s + i + ",0)";
    let o = e.style;
    o.transform = r, o.mozTransform = r, o.msTransform = r
};
M.O = (e, t) => {
    M.S(e, "opacity", t)
};
M.D = (e, t) => {
    t = t === "n" ? "none" : t === "f" ? "flex" : "block", M.S(e, "display", t)
};
M.S = (e, t, s) => M.Select(e).style[t] = s;
M.R = (e, t) => (t = M.Is.und(t) ? 100 : 10 ** t, Math.round(e * t) / t);
M.E = (e, t, s, i, r) => {
    const o = M.SelectAll(e);
    i = i === "r" ? "remove" : "add", o.forEach(n => {
        n[i + "EventListener"](t, s, r)
    })
};
M.L = e => e?.length ?? 0;
M.De = (e, t, s) => {
    e.dispatchEvent(new CustomEvent(t, s))
};
M.Cl = (e, t, s) => {
    if (M.Is.und(e)) return;
    const i = M.SelectAll(e);
    t = t === "a" ? "add" : t === "r" ? "remove" : "toggle", i.forEach(r => {
        r.classList[t](s)
    })
};
M.Cr = (e, t = null) => {
    const s = document.createElement(e);
    return t && (s.className = t), s
};
M.Tg = (e, t = !1) => t ? e.currentTarget : e.target;
M.Pn = e => e.parentNode;
M.C = e => Array.from(M.Select(e)?.children ?? []);
M.Sp = e => e.stopPropagation();
M.In = e => location.href.includes(e);
M.PZ = e => 9 < e ? "" + e : "0" + e;
M.Debounce = (e, t) => {
    var s;
    return function() {
        var i = arguments,
            r = this;
        clearTimeout(s), s = setTimeout(function() {
            e.apply(r, i)
        }, t)
    }
};
M.throttle = (e, t) => {
    var s, i;
    return function() {
        var r = this,
            o = +new Date,
            n = arguments;
        s && o < s + t ? (clearTimeout(i), i = setTimeout(function() {
            s = o, e.apply(r, n)
        }, t)) : (s = o, e.apply(r, n))
    }
};
M.SSP = (e, t, s) => {
    (s ? M.Select(s) : M.Dom.root).style.setProperty(e, t)
};
M.SGP = (e, t) => M.Dom.root.style.getPropertyValue(t);
M.GBCR = (e, t = null) => {
    const s = M.Select(e).getBoundingClientRect();
    return t ? s[t] : s
};
M.Tab = class {
    constructor() {
        this.arr = [], this.pause = 0, M.Bind(this, ["v"]), M.E(document, "visibilitychange", this.v, "a")
    }
    add(e) {
        this.arr.push(e)
    }
    v() {
        const e = performance.now();
        let t, s;
        document.hidden ? (this.pause = e, s = "stop") : (t = e - this.pause, s = "start");
        const i = this.l();
        for (let r = i; r >= 0; r--) this.arr[r][s](t)
    }
    l() {
        return this.arr.length - 1
    }
};
M.Raf = class {
    static Tab = new M.Tab;
    constructor() {
        M.Bind(this, ["loop", "tOff", "tOn"]), this.arr = [], this.pause = 0, this.on = !0, M.Raf.Tab.add({
            stop: this.tOff,
            start: this.tOn
        }), this.raf()
    }
    tOff() {
        this.on = !1
    }
    tOn(e) {
        const t = this.l();
        for (let s = t; s >= 0; s--) this.arr[s].sT += e;
        this.on = !0
    }
    add(e) {
        this.arr.push(e)
    }
    remove(e) {
        const t = this.l();
        for (let s = t; s >= 0; s--)
            if (this.arr[s].id === e) {
                this.arr.splice(s, 1);
                return
            }
    }
    loop(e) {
        if (this.on) {
            const t = this.l();
            for (let s = t; s >= 0; s--) {
                const i = this.arr[s];
                i.sT || (i.sT = e);
                const r = e - i.sT;
                i.cb(r)
            }
        }
        this.raf()
    }
    raf() {
        requestAnimationFrame(this.loop)
    }
    l() {
        return this.arr.length - 1
    }
};
M.RafR = class {
    static Raf = new M.Raf;
    static id = 0;
    constructor(e) {
        M.Bind(this, ["run", "stop"]), this.cb = e, this.id = M.RafR.id, this.on = !1, M.RafR.id++
    }
    run() {
        this.on || (M.RafR.Raf.add({
            id: this.id,
            cb: this.cb
        }), this.on = !0)
    }
    stop() {
        this.on && (M.RafR.Raf.remove(this.id), this.on = !1)
    }
};
M.Throttle = class {
    constructor({
        delay: e,
        onlyAtEnd: t,
        cb: s
    }) {
        this.del = e, this.onlyAtEnd = t, this.cb = s, this.last = 0, this.t = 0
    }
    run() {
        let e = !0;
        const t = Date.now();
        this.last && t < this.last + this.del || e ? (e = !1, clearTimeout(this.t), this.t = setTimeout(s => {
            this.last = t, this.cb()
        }, this.del)) : (this.last = t, this.onlyAtEnd || (e = !1, this.cb()))
    }
};
M.RO = class {
    constructor(e) {
        this.E = D.isM ? "orientationchange" : "resize", this.tick = !1, this.arr = [], M.Bind(this, ["fn", "gRaf", "run"]), this.t = new M.Throttle({
            delay: 100,
            onlyAtEnd: !0,
            cb: this.gRaf
        }), this.raf = new M.RafR(this.run), M.E(window, this.E, this.fn, "a")
    }
    add(e) {
        this.arr.push(e)
    }
    remove(e) {
        const t = this.l();
        for (let s = t; s >= 0; s--)
            if (this.arr[s].id === e) {
                this.arr.splice(s, 1);
                return
            }
    }
    fn(e) {
        this.e = e, this.t.run()
    }
    gRaf() {
        this.tick || (this.tick = !0, this.raf.run())
    }
    run() {
        const e = this.l();
        for (let t = e; t >= 0; t--) this.arr[t].cb(this.e);
        this.raf.stop(), this.tick = !1
    }
    l() {
        return this.arr.length - 1
    }
};
M.ROR = class {
    static Ro = new M.RO;
    static RoId = 0;
    constructor(e) {
        this.cb = e, this.isOn = !1, this.id = M.ROR.RoId, M.ROR.RoId++
    }
    on() {
        this.isOn || (M.ROR.Ro.add({
            id: this.id,
            cb: this.cb
        }), this.isOn = !0)
    }
    off() {
        M.ROR.Ro.remove(this.id), this.isOn = !1
    }
};
M.Dom = {
    get html() {
        return document.documentElement
    },
    get body() {
        return document.body
    },
    get root() {
        return document.documentElement
    },
    get header() {
        return M.Select("#header .c-header")
    },
    get nav() {
        return M.Select("#nav")
    },
    get app() {
        return M.Select("#app")
    },
    get footer() {
        return M.Select("#footer")
    }
};
Element.prototype.Select = function(e) {
    return this.querySelector(e)
};
Element.prototype.select = function(e) {
    return this.querySelector(e)
};
Element.prototype.SelectAll = function(e) {
    return Array.from(this.querySelectorAll(e))
};
Element.prototype.selectAll = function(e) {
    return Array.from(this.querySelectorAll(e))
};
Math.radToDeg = e => e * 180 / Math.PI;
Math.degToRad = e => e * Math.PI / 180;
M;
class g {
    constructor({
        modules: t
    }) {
        this.modules = t, this.currentModules = {}, this.activeModules = {}, this.moduleId = 0
    }
    init() {
        this.safeDestroy(), M.SelectAll("[data-module]:not([data-module-state=initialized])").forEach(s => {
            Array.from(s.attributes).forEach(i => {
                if (i.name.startsWith("data-module-")) {
                    let r = !1;
                    const o = i.name.replace("data-module-", "").split("-");
                    let n = this.toCamel(o);
                    if (this.modules[n] ? r = !0 : this.modules[this.toUpper(n)] && (n = this.toUpper(n), r = !0), r) {
                        const l = {
                            el: s,
                            name: n,
                            dataName: o.join("-")
                        };
                        let a = i.value;
                        (!a || a === "true") && (this.moduleId++, a = "m" + this.moduleId, s.setAttribute(i.name, a));
                        const c = n + "-" + a;
                        if (s.setAttribute("data-module-id", c), this.currentModules[c]) return;
                        const h = new this.modules[n](l);
                        this.addActiveModule(n, a, h), this.currentModules[c] = h
                    }
                }
            })
        }), Object.entries(this.currentModules).forEach(([s, i]) => {
            this.initModule(i)
        })
    }
    initModule(t) {
        t.mInit(this.activeModules), t.init()
    }
    addActiveModule(t, s, i) {
        this.activeModules[t] ? Object.assign(this.activeModules[t], {
            [s]: i
        }) : this.activeModules[t] = {
            [s]: i
        }
    }
    destroy() {
        window.alert("destroy"), this.destroyModules()
    }
    safeDestroy() {
        Object.entries(this.currentModules).forEach(([i, r]) => {
            r.el.isConnected || (this.destroyModule(r), delete this.currentModules[i])
        });
        const t = M.Select("[data-page-state=old]");
        t?.selectAll("[data-module]", t)?.forEach(i => {
            const r = i.getAttribute("data-module-id"),
                o = this.currentModules[r];
            o && (this.destroyModule(o), delete this.currentModules[r])
        })
    }
    destroyModules() {
        Object.entries(this.currentModules).forEach(([t, s]) => {
            this.destroyModule(s)
        }), this.activeModules = {}, this.currentModules = []
    }
    destroyModule(t) {
        t.mDestroy(), t.destroy()
    }
    toCamel(t) {
        return t.reduce((s, i) => s + this.toUpper(i))
    }
    toUpper(t) {
        return t.charAt(0).toUpperCase() + t.slice(1)
    }
}
class y {
    constructor(t) {
        this.mAttr = "data-" + t.dataName, this.mCaptureEvents = ["mouseenter", "mouseleave"], this.mStates = {
            init: !1
        }, this.el = t.el
    }
    mInit(t) {
        this.mStates.init || (this.modules = t, this.mCheckEventTarget = this.mCheckEventTarget.bind(this), this.el.setAttribute("data-module-state", "initialized"), this.events && Object.keys(this.events).forEach(s => this.mAddEvent(s)), this.safeE(), this.mStates.init = !0)
    }
    mDestroy() {
        this.events && Object.keys(this.events).forEach(t => this.mRemoveEvent(t)), this.e?.("r")
    }
    mAddEvent(t) {
        const s = !!this.mCaptureEvents.includes(t);
        this.el.addEventListener(t, this.mCheckEventTarget, s)
    }
    mRemoveEvent(t) {
        const s = !!this.mCaptureEvents.includes(t);
        this.el.removeEventListener(t, this.mCheckEventTarget, s)
    }
    mCheckEventTarget(t) {
        const s = this.events[t.type];
        if (typeof s == "string") this[s](t);
        else {
            const i = "[" + this.mAttr + "]";
            let r = t.target;
            if (this.mCaptureEvents.includes(t.type)) r.matches(i) && this.mCallEventMethod(t, s, r);
            else
                for (; r && r !== document && !(r.matches(i) && this.mCallEventMethod(t, s, r) != "undefined");) r = r.parentNode
        }
    }
    mCallEventMethod(t, s, i) {
        i.getAttribute(this.mAttr).split(" ").forEach(n => {
            if (s.hasOwnProperty(n)) {
                const l = s[n];
                t.hasOwnProperty("currentTarget") || Object.defineProperty(t, "currentTarget", {
                    value: i
                }), t.hasOwnProperty("curTarget") || Object.defineProperty(t, "curTarget", {
                    value: i
                }), this[l](t)
            }
        })
    }
    $(t, s) {
        const i = "[" + this.mAttr + "~=" + t + "]";
        return (s || this.el).select(i)
    }
    $$(t, s) {
        const i = "[" + this.mAttr + "~=" + t + "]";
        return (s || this.el).selectAll(i)
    }
    parent(t, s) {
        const i = "[" + this.mAttr + "~=" + t + "]";
        let r = s.parentNode;
        for (; r && r !== document;) {
            if (r.matches(i)) return r;
            r = r.parentNode
        }
    }
    select(t, s) {
        return (s || this.el).select(t)
    }
    selectAll(t, s) {
        return (s || this.el).selectAll(t)
    }
    getData(t, s) {
        return (s || this.el).getAttribute(this.mAttr + "-" + t)
    }
    call({
        func: t,
        args: s,
        mod: i,
        id: r
    }) {
        this.modules[i] && (r ? this.modules[i][r] && this.modules[i][r][t](s) : Object.keys(this.modules[i]).forEach(o => {
            this.modules[i][o][t](s)
        }))
    }
    on({
        e: t,
        mod: s,
        func: i,
        id: r
    }) {
        this.modules[s] && (r ? this.modules[s][r].el.addEventListener(t, o => i(o)) : Object.keys(this.modules[s]).forEach(o => {
            this.modules[s][o].el.addEventListener(t, n => i(n))
        }))
    }
    safeE() {
        this.e?.("r"), this.e?.("a")
    }
    init() {}
    destroy() {}
}
class v extends y {
    constructor(t) {
        super(t), this.observer = null, this.events = {
            click: {
                open: "openModal"
            }
        }
    }
    get modal() {
        return document.querySelector('.knr-lpo [data-lpo="modal"]')
    }
    // init() {
    //     document.body.insertAdjacentElement("afterbegin", this.$("modal_wrapper")), this.e(), this.observeDOM()
    // }
    init() {
        this.el = this.$("modal_wrapper");
        this.el.__instance = this; // ✅ expose instance

        document.body.insertAdjacentElement("afterbegin", this.el);
        this.e();
        this.observeDOM();
    }
    e() {
        M.E(this.$$("close"), "click", () => this.closeModal())
    }
    observeDOM() {
        this.observer = new MutationObserver(() => {
            this.wrapLabelsWithHelp()
        }), this.observer.observe(this.modal, {
            childList: !0,
            subtree: !0
        }), this.wrapLabelsWithHelp()
    }
    wrapLabelsWithHelp() {
        this.modal.querySelectorAll(".cl-po--label:not(.is-wrapped)").forEach(s => {
            const i = s.parentElement.querySelector(".cl-po--help");
            if (!i) return;
            s.classList.add("is-wrapped");
            const r = document.createElement("div");
            r.className = "cl-po--label-wrapper", s.parentElement.insertBefore(r, s), r.appendChild(s), r.appendChild(i)
        })
    }
    openModal() {
        M.Cl(this.modal, "r", "is-not-active"), document.body.classList.add("overflow-hidden");
        // validatePersonalization();
    }
    closeModal() {
        M.Cl(this.modal, "a", "is-not-active"), document.body.classList.remove("overflow-hidden")
    }
    destroy() {
        this.observer && this.observer.disconnect()
    }
}
const S = Object.freeze(Object.defineProperty({
        __proto__: null,
        Lpo: v
    }, Symbol.toStringTag, {
        value: "Module"
    })),
    b = new g({
        modules: S
    });
b.init();
(() => {
    const e = () => {
        M.SelectAll(".gbcr").forEach(t => {
            M.SSP("--gbcr-h", M.GBCR(t, "height") + "px", t), M.SSP("--gbcr-w", M.GBCR(t, "width") + "px", t), M.SSP("--gbcr-left", M.GBCR(t, "left") + "px", t), M.SSP("--gbcr-top", M.GBCR(t, "top") + "px", t)
        })
    };
    e(), window.addEventListener("resize", e)
})();
class C {
    constructor(t = {}) {
        this.motifConfig = t.motifConfig || {}, this.productImages = t.productImages || {}, this.selectors = {
            variantRadios: '[data-variant-buttons] input[type="radio"]',
            lpoWrapper: ".cl-po--wrapper",
            initialsInput: 'input[name="properties[Initiale]"]',
            initialsWrapper: '[data-option="Initiale"]',
            colorSelects: ['select[name="properties[Couleur 1]"]', 'select[name="properties[Couleur 2]"]', 'select[name="properties[Couleur 3]"]'],
            colorWrappers: ['[data-option="Couleur 1"]', '[data-option="Couleur 2"]', '[data-option="Couleur 3"]'],
            lpoImage: "img.cl-po--preview"
        }, this.elements = {}, this.choicesInstances = {}, this.currentMotif = null, this.init()
    }
    init() {
        if (this.cacheElements(), !this.validateElements()) {
            console.warn("ProductOptionsSync: Éléments manquants, initialisation annulée");
            return
        }
        this.bindEvents(), this.syncInitialState(), console.log("ProductOptionsSync: Initialisé avec succès")
    }
    cacheElements() {
        this.elements = {
            variantRadios: document.querySelectorAll(this.selectors.variantRadios),
            lpoWrapper: document.querySelector(this.selectors.lpoWrapper),
            initialsInput: document.querySelector(this.selectors.initialsInput),
            initialsWrapper: document.querySelector(this.selectors.initialsWrapper),
            colorSelects: this.selectors.colorSelects.map(t => document.querySelector(t)),
            colorWrappers: this.selectors.colorWrappers.map(t => document.querySelector(t)),
            lpoImage: document.querySelector(this.selectors.lpoImage)
        }
    }
    validateElements() {
        return console.log(this.elements.variantRadios.length, this.elements), this.elements.variantRadios.length > 0 && this.elements.initialsInput
    }
    // bindEvents() {
    //     this.elements.variantRadios.forEach(t => {
    //         t.addEventListener("change", s => this.onVariantChange(s))
    //     })
    // }
    bindEvents() {
        this.elements.variantRadios.forEach(t => {
            t.addEventListener("change", s => {
                console.log('Variant changed');
                console.log('Event:', s);

                this.onVariantChange(s);
            });
        });

           document.addEventListener("cl:variant:change", (event) => {
                clearPersonalizationInputs();
                console.log("custom e event",event);
                this.onVariantChange(event);
            });
    }

    syncInitialState() {
        const t = document.querySelector(`${this.selectors.variantRadios}:checked`);
        t && this.onVariantChange({
            target: t
        })
    }
    // onVariantChange(t) {
    //     const s = t.target.value;
    //     this.currentMotif = s, this.updateFormConfig(s)
    // }

    onVariantChange(t) {
        let motifValue = null;
        let variantId;

        if (t?.target instanceof HTMLInputElement) {
            motifValue = t.target.value;
        }

        else if (t?.detail?.variant) {
            const variant = t.detail.variant;
            motifValue = variant.option1;
            variantId = variant.id;
        }

        if (!motifValue) {
            console.warn("Motif not resolved from event", t);
            return;
        }

        console.log("Motif Value:", motifValue);

        this.currentMotif = motifValue;
        this.updateFormConfig(motifValue);
        const buttonElem = document.querySelector("[data-lpo='modal_wrapper']");
        if(buttonElem && variantId){
            buttonElem.querySelector("form input[name='id']").value = variantId;
        }
        
    }


    updateFormConfig(t) {
        const s = this.getMotifConfig(t);
        if (!s) {
            console.warn("ProductOptionsSync: Config non trouvée pour", t);
            return
        }
        this.resetForm(), this.updateInitialsField(s), this.updateColorFields(s), this.updateImage(s)
    }
    resetForm() {
        this.elements.initialsInput && (this.elements.initialsInput.value = ""), this.elements.colorSelects.forEach(t => {
            t && (t.selectedIndex = 0, this.triggerChoicesUpdate(t, ""))
        })
    }

    // getMotifConfig(t) {
    //     const s = t.toLowerCase().trim();
    //     for (const [i, r] of Object.entries(this.motifConfig))
    //         if (i.toLowerCase().trim() === s) return r;
    //     for (const [i, r] of Object.entries(this.motifConfig))
    //         if (i.toLowerCase().includes(s) || s.includes(i.toLowerCase())) return r;
    //     return null
    // }

    decodeHtml(str) {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }

    getMotifConfig(t) {
        const normalize = (val) =>
            this.decodeHtml(String(val))
                .toLowerCase()
                .replace(/\u00a0/g, " ")   // NBSP
                .replace(/\s+/g, " ")
                .trim();

        const s = normalize(t);

        // console.log("Normalized input:", `"${s}"`);

        for (const [i, r] of Object.entries(this.motifConfig)) {
            const key = normalize(i);

            // console.log({
            //     originalKey: i,
            //     decodedKey: this.decodeHtml(i),
            //     normalizedKey: `"${key}"`,
            //     input: `"${s}"`,
            //     isExactMatch: key === s
            // });

            if (key === s) {
                // console.log("✅ Exact match FOUND:", i);
                return r;
            }
        }

        // fallback partial match (optional)
        for (const [i, r] of Object.entries(this.motifConfig)) {
            const key = normalize(i);

            if (key.includes(s) || s.includes(key)) {
                // console.log("⚠️ Partial match FOUND:", i);
                return r;
            }
        }

        console.warn("❌ No motif config matched for:", `"${s}"`);
        return null;
    }


    updateInitialsField(t) {
        const s = this.elements.initialsInput,
            i = this.elements.initialsWrapper;
        if (!s) return;
        const r = t.initial_max || 3;
        s.setAttribute("maxlength", r), s.value.length > r && (s.value = s.value.substring(0, r));
        const o = i?.querySelector(".cl-po--help");
        o && (o.textContent = `${r} lettre${r>1?"s":""} max.`);
        const n = {
            1: "Ex : C",
            2: "Ex : CL",
            3: "Ex : CLP"
        };
        s.placeholder = n[r] || `Ex : ${"X".repeat(r)}`, i && (i.style.display = r > 0 ? "" : "none")
    }
    updateColorFields(t) {
        const s = t.couleur_max || 3;
        this.elements.colorWrappers.forEach((i, r) => {
            if (!i) return;
            const o = r < s;
            i.style.display = o ? "" : "none", !o && this.elements.colorSelects[r] && (this.elements.colorSelects[r].value = "", this.triggerChoicesUpdate(this.elements.colorSelects[r], ""))
        })
    }
    updateImage(t) {
        if (this.elements.lpoImage.src = this.productImages[t.nom]?.image_url || "", this.elements.lpoImage.alt = this.productImages[t.nom]?.image_alt || "", !t.indication_url) return;
        let s = this.elements.lpoWrapper?.querySelector(".cl-po--indication-image");
        if (!s && this.elements.lpoWrapper) {
            s = document.createElement("div"), s.className = "cl-po--indication-image", s.innerHTML = `
      <img src="" alt="Indication motif" />
      <p class="cl-po--indication-dimension"></p>
    `;
            const i = this.elements.lpoWrapper.querySelector('[data-option="Initiale"]');
            i && i.before(s)
        }
        if (s) {
            const i = s.querySelector("img");
            i && (i.src = t.indication_url, i.alt = `Indication ${t.nom||""}`);
            const r = s.querySelector(".cl-po--indication-dimension");
            r && (r.textContent = t.dimension || "")
        }
    }
    triggerChoicesUpdate(t, s) {
        if (!t) return;
        const i = t.closest(".choices");
        if (!i) return;
        const r = i.querySelector(".choices__item--selectable");
        if (r) {
            const o = Array.from(t.options).find(l => l.value === s),
                n = r.querySelector(".o--text");
            n && o && (n.textContent = o.text || "Choisissez une option")
        }
        t.dispatchEvent(new CustomEvent("choices:update", {
            bubbles: !0,
            detail: {
                value: s
            }
        }))
    }
    setMotifConfig(t) {
        this.motifConfig = t
    }
    refresh() {
        this.syncInitialState()
    }
}

function u() {
    const e = document.querySelector(".cl-po--wrapper .choices"),
        t = document.querySelector("[data-variant-buttons]");
    e && t ? window.productOptionsSync = new C({
        motifConfig: KNR.LPO.motifConfig,
        productImages: KNR.LPO.productImages
    }) : setTimeout(u, 100)
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", u) : u();
window.motifBroderieConfig = KNR.LPO.motifConfig;
window.productVariantImages = KNR.LPO.productImages;


// custom code

const productForm = document.querySelector("[data-lpo='modal_wrapper'] product-form form");

function validatePersonalization() {
  if (!(productForm.querySelector("button"))) return;

  const visibleOptions = document.querySelectorAll(
    '.cl-po--option:not([style*="display: none"])'
  );

  let isValid = true;

  visibleOptions.forEach(option => {
    const input = option.querySelector('input.cl-po--input[type="text"]');
    const select = option.querySelector('select.cl-po--input');

    // Validate text input
    if (input && !input.value.trim()) {
      isValid = false;
    }

    // Validate select
    if (select && !select.value) {
      isValid = false;
    }

    console.log("isValid",isValid);
  });

  productForm.querySelector("button").disabled = !isValid;
}


function clearPersonalizationInputs() {
  if (!productForm) return;

  productForm
    .querySelectorAll('.cl-personalize-input')
    .forEach(input => input.remove());
}

function setFormProperty(name, value) {
  if (!productForm) return;

  let input = productForm.querySelector(`input[name="properties[${name}]"]`);

  if (!value) {
    // Remove input if value is empty (important for hidden fields)
    if (input) input.remove();
    return;
  }

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.classList.add('cl-personalize-input');
    input.name = `properties[${name}]`;
    productForm.appendChild(input);
  }

  input.value = value;
}


document.addEventListener('input', (e) => {
  const input = e.target;

  if (input.classList.contains('cl-po--input') && input.type === 'text') {
    const optionName = input
      .closest('.cl-po--option')
      ?.dataset.option;

    if (!optionName) return;
    console.log("Input value",input.value);

    setFormProperty(optionName, input.value.trim());
    // validatePersonalization();
  }
});


document.addEventListener('change', (e) => {
  const select = e.target;

  if (!select.matches('select.cl-po--input')) return;

  const optionWrapper = select.closest('.cl-po--option');

  // Skip hidden color fields
  if (optionWrapper && optionWrapper.style.display === 'none') {
    setFormProperty(optionWrapper.dataset.option, '');
    return;
  }

  const optionName = optionWrapper?.dataset.option;
  if (!optionName) return;

  setFormProperty(optionName, select.value);
//   validatePersonalization();
});

  productForm.querySelector("button").addEventListener("click", (event) => {
    const modalWrapper = document.querySelector("[data-lpo='modal_wrapper']");
    modalWrapper?.__instance?.closeModal();
  });
// custom code